import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { resetPasswordEmail } from '../../actions/firebase_actions';

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            success: '',
        };
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    onFormSubmit(event) {
        event.preventDefault();
        const email = this.refs.email.value;
        this.props.resetPasswordEmail(email).then((data) => {
            if (data.payload.errorCode) {
                this.setState({ message: data.payload.errorMessage,success:"" });
            } else {
                this.setState({ success: 'Password reset email sent.',message:"" });
            }
        });
    }

    render() {
        return (
            <div>
                <form role="form" onSubmit={this.onFormSubmit}>
                  <span className="headerText">Reset Password</span><br/>
                    <p className="errorText">
                      {this.state.message}
                    </p>
                    <p className="successText">
                      {this.state.success}
                    </p>
                  <div className="form-group">
                    <label htmlFor="txtEmail" className="titleText">Email address</label>
                    <input
                    type="email" className="form-control inputText" id="txtEmail" ref="email" placeholder="Enter email"
                    name="email"
                  />
                </div>
                  <button type="submit" className="buttonStyle">Reset Password</button>
              </form>
            </div>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        resetPasswordEmail,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/app/components/reset_password/index.jsx